import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import type { PackageFormState } from '@openx/types/package.ts';
import { priceFormat } from '@openx/utils/lib/priceFormat.ts';
import { useTranslation } from 'react-i18next';
import { usePackageContext } from '../../../utils/context/PackageContext.tsx';

type PMPackageRatesProps = {
  pckg: PackageFormState;
};

export function PMPackageRates({ pckg }: PMPackageRatesProps) {
  const { t } = useTranslation();
  const { useRelatedAccountsFetch } = usePackageContext();

  const { relatedAccounts = {}, loading: relatedAccountsLoading } = useRelatedAccountsFetch([pckg]);
  const currency = relatedAccounts[pckg.account_uid]?.currency;

  return (
    <FormSection
      title={t('Private Marketplace Package Rates')}
      description={t(
        'This section enables you to make a package discoverable and provide package rate information for Private Marketplace deals.'
      )}
    >
      <FieldDetails
        title={t('Rate Card Price')}
        loading={relatedAccountsLoading}
        value={priceFormat(pckg.private_market?.default_rate_card_cpm || null, currency)}
      />
      <FieldDetails
        title={t('Discounted / List Price')}
        loading={relatedAccountsLoading}
        value={priceFormat(pckg.private_market?.default_discounted_cpm || null, currency)}
      />
      <FieldDetails onOffControl title={t('Discoverable to all buyers')} value={pckg.private_market?.discoverable} />
    </FormSection>
  );
}
